import { ModeEditOutlineOutlined } from "@mui/icons-material";
import React from "react";

/**
 * Common reusable Edit icon component.
 *
 * @param {Object} props
 * @param {Function} props.onClick - Function to trigger when icon is clicked.
 * @param {string} [props.color] - Custom color (defaults to primary color).
 * @param {number|string} [props.size] - Icon size (default: 17).
 * @param {string} [props.className] - Optional extra classes for styling or margin.
 */
const EditIcon = ({ onClick, survey_theme }) => {
  return (
    <div className="me-1" onClick={onClick}>
      <ModeEditOutlineOutlined
        style={{
          fontSize: "17px",
          color: survey_theme?.primaryColor,
        }}
      />
    </div>
  );
};

export default EditIcon;
